<app-form-wrapper [title]="'not_found.page_bg' | translate">
  <div class="header-xl font font--bold color-primary">{{ 'not_found.text' | translate }}</div>
</app-form-wrapper>

